export const UNDO_DELETE_DELAY_MS = 10_000

export const UNDO_DELETE_COPY = {
	assetDeleted: 'Asset Deleted',
	assetsDeleted: 'Assets Deleted',
	roundDeleted: 'Round Deleted',
	assetRestored: 'Asset Restored',
	assetsRestored: 'Assets Restored',
	roundRestored: 'Round restored',
	undo: 'Undo'
} as const
